import { render, staticRenderFns } from "./AreaBox.vue?vue&type=template&id=6c252674&scoped=true"
import script from "./AreaBox.vue?vue&type=script&lang=js"
export * from "./AreaBox.vue?vue&type=script&lang=js"
import style0 from "./AreaBox.vue?vue&type=style&index=0&id=6c252674&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c252674",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c252674')) {
      api.createRecord('6c252674', component.options)
    } else {
      api.reload('6c252674', component.options)
    }
    module.hot.accept("./AreaBox.vue?vue&type=template&id=6c252674&scoped=true", function () {
      api.rerender('6c252674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HotpotModal/AreaBox.vue"
export default component.exports